module.exports = __webpack_public_path__ + "img/8.e174a795.png";